import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { useOrchidPro } from "components/Dashboard/DoctorDashboard/contexts/orchid-pro-context";
import queryICDCodes from "services/queryICDCodes";

type Context = {
  icdCodesList: ICDCodesList;
  busy: boolean;
};
const ICDCodesContext = createContext<Context>({
  icdCodesList: {},
  busy: false,
});

type Props = { children: ReactNode };

export const ICDCodesListContextProvider = ({ children }: Props) => {
  const { orchidPro } = useOrchidPro();
  const [icdCodesList, setICDCodesList] = useState<ICDCodesList>({});
  const [busy, setBusy] = useState(true);

  // get icdCodesList on init
  useEffect(() => {
    if (!orchidPro) {
      return;
    }
    setBusy(true);
    queryICDCodes()
      .then(setICDCodesList)
      .catch(console.error)
      .finally(() => setBusy(false));
  }, [orchidPro]);

  return (
    <ICDCodesContext.Provider
      value={{
        icdCodesList,
        busy,
      }}
    >
      {children}
    </ICDCodesContext.Provider>
  );
};

export const useICDCodesList = () => useContext(ICDCodesContext);
